import OrgsAPI from "./orgs"
import UsersAPI from "./users"

export default {
  orgs: (jwt) => new OrgsAPI(jwt),
  users: (jwt) => new UsersAPI(jwt)
}
